import { $color } from "@/utils/cssVarUtils"
import type { SystemStyleObject } from "@chakra-ui/theme-tools"

const baseStyle: SystemStyleObject = {
  borderColor: $color("scene-border"),
}

export const Divider = {
  baseStyle,
}